import { formatInTz } from './timezones';

let _tz = 'UTC';

export function setGlobalTz(tz: string) { _tz = tz; }
export function getTz(): string { return _tz; }

export function fmtTs(
  value: string | Date | number,
  opts: Intl.DateTimeFormatOptions = { dateStyle: 'medium', timeStyle: 'short' },
): string { return formatInTz(value, _tz, opts); }

export function fmtDate(value: string | Date | number): string {
  return formatInTz(value, _tz, { dateStyle: 'medium' });
}
